import { PEP_FIELD } from '@app/configs/solvencyDeclaration';
import { renderField } from '@modules/borrower/utils/renderFormField';
const FieldWithError = ({ field, form, t, parentLabel, validateField }) => {
    const error = form.formState.errors[field.name];
    const errorKey = field.name === PEP_FIELD ? 'pep_error' : 'required_field';
    return (<div>
            {renderField(form, field, t, () => validateField(field.name), parentLabel)}
            {error && (<div className="text-critical-primary-initial body-s mt-1">
                    {t(`financing.solvency_declaration.${errorKey}`)}
                </div>)}
        </div>);
};
export default FieldWithError;
